<script setup>
import { onMounted } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';

// Store data
const currentUser = useMapGetter('getCurrentUser');

const $store = useStore();

// Account composable
const { accountId } = useAccount();

onMounted(async () => {
  const params = Object.fromEntries(
    new URLSearchParams(window.location.search).entries()
  );

  const telefone = params.telefone;
  const inboxId = params.id;
  const message = params.text || '';

  // Se NÃO houver telefone E NÃO houver id → redireciona para home
  if (!telefone && !inboxId) {
    window.location.assign(`/app/accounts/${accountId.value}/dashboard`);
  }

  let contact = await $store.dispatch('contacts/exists', {
    search: telefone,
  });

  if (!contact) {
    contact = await $store.dispatch('contacts/create', {
      name: telefone,
      phone_number: `+${telefone}`,
    });
  }
  const contactableInboxes = await $store.dispatch(
    'contacts/fetchContactableInbox',
    contact.id
  );

  const inboxList = contactableInboxes || [];

  const inboxObject = inboxList.find(inbox => {
    return inbox.inbox?.id && inbox.inbox?.id === Number(inboxId);
  });

  if (!inboxObject) {
    // Se NÃO houver inbox correspondente → redireciona para home
    window.location.assign(`/app/accounts/${accountId.value}/dashboard`);
  }

  const payload = {
    inboxId: inboxId,
    sourceId: inboxObject.source_id,
    contactId: contact.id,
    assigneeId: currentUser.value.id,
  };

  if (message.length > 0) {
    payload.message = { content: message };
  }

  const isFromWhatsApp = true;
  const data = await $store.dispatch('contactConversations/create', {
    params: payload,
    isFromWhatsApp,
  });

  window.location.assign(
    `/app/accounts/${data.account_id}/conversations/${data.id}`
  );
  // app/accounts/${data.account_id}/conversations/${data.id}
});
</script>

<template>
  <div class="start-chat-container">
    <!-- Blank page for now -->
  </div>
</template>

<style scoped>
.start-chat-container {
  width: 100%;
  height: 100vh;
  background: #fff;
}
</style>
